<div
  *ngIf="
    scheduledOrder.Metadata &&
    scheduledOrder.Metadata.ShippingRateCalculationErrors
  "
  class="dialog-content"
>
  <!-- Description -->
  <p class="will-fail-to-process-text">
    The following Shipping Rates match the Scheduled Order but failed
    calculations:
  </p>

  <!-- Error List -->
  <div class="item-list">
    <div
      class="validation-check-item"
      *ngFor="
        let shippingRateCalculationError of shippingRateCalculationErrors;
        let i = index
      "
    >
      <!-- Shipping Rate Name -->
      <p class="label-bold">
        Shipping Rate:
        <span>{{ shippingRateCalculationError.ShippingRate.Name }}</span>
      </p>

      <!-- Error Details -->
      <div class="error">
        <i class="pi pi-times-circle failed"></i>
        <div style="flex: 1">
          <p>{{ shippingRateCalculationError.Description }}</p>
          <div
            class="show-hide-details"
            (click)="toggleDetails(i)"
            *ngIf="shippingRateCalculationError.RawError"
          >
            <i
              class="pi"
              [ngClass]="{
                'pi-chevron-down': isShowingDetails(i),
                'pi-chevron-right': !isShowingDetails(i),
              }"
            ></i>
            <span class="show-hide-details-text">
              {{
                isShowingDetails(i) ? "Hide raw response" : "View raw response"
              }}
            </span>
          </div>
        </div>
      </div>

      <!-- Raw Error Details (Expandable) -->
      <p class="details-text" *ngIf="isShowingDetails(i)">
        {{ shippingRateCalculationError.RawError }}
      </p>
    </div>
  </div>
</div>

<!-- Footer Actions -->
<div class="dialog-footer">
  <p-button
    label="Close"
    severity="secondary"
    (onClick)="close()"
    styleClass="close-button"
  />
</div>
